/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";

import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";

import { TableHeadCell } from "../types";

interface TableHeadProps<T> {
  headCells: TableHeadCell<T>[];
  withActions?: boolean;
}

const ExtendedTableHead = <T extends { id: string }>(
  props: TableHeadProps<T>
) => {
  const { headCells, withActions } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells.map(
          ({ id, secure, cell, transform, width, label, ...cellProps }) => (
            <TableCell
              variant="head"
              key={id.toString()}
              sx={{ width }}
              {...cellProps}
              id={id.toString()}
            >
              {label}
            </TableCell>
          )
        )}
        {withActions && <TableCell variant="head" />}
      </TableRow>
    </TableHead>
  );
};

export default ExtendedTableHead;
